import { render, staticRenderFns } from "./TabuladorPuestos.vue?vue&type=template&id=3bc554be&scoped=true"
import script from "./TabuladorPuestos.vue?vue&type=script&lang=js"
export * from "./TabuladorPuestos.vue?vue&type=script&lang=js"
import style0 from "./TabuladorPuestos.vue?vue&type=style&index=0&id=3bc554be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc554be",
  null
  
)

export default component.exports